// components/StackedCompletionBar.jsx
import React from 'react'

const DEFAULT_COLORS = {
    pass: '#52c41a', // green
    fail: '#db2114', // red
    retest: '#1890ff', // blue
    track: '#faad14', // #f0f0f0 pending/background
}

const tiny = (n) => Math.max(0, Number.isFinite(n) ? n : 0)

export default function StackCompletionBar({
    percents,
    height = 14,
    radius = 6,
    colors = DEFAULT_COLORS,
    showTooltips = true,
}) {
    const passW = tiny(percents?.pass)
    const failW = tiny(percents?.fail)
    const retestW = tiny(percents?.retest)
    const pendingW = tiny(percents?.pending)

    const Segment = ({ w, color, label }) => (
        <div
            style={{ width: `${w}%`, height: '100%', background: color }}
            aria-label={label}
            title={showTooltips ? label : undefined}
        />
    )

    return (
        <div
            style={{
                position: 'relative',
                width: '100%',
                height,
                background: colors.track,
                borderRadius: radius,
                overflow: 'hidden',
            }}
        >
            <div style={{ display: 'flex', width: '100%', height: '100%' }}>
                {passW > 0 && (
                    <Segment
                        w={passW}
                        color={colors.pass}
                        label={`Pass: ${passW.toFixed(0)}%`}
                    />
                )}
                {failW > 0 && (
                    <Segment
                        w={failW}
                        color={colors.fail}
                        label={`Fail: ${failW.toFixed(0)}%`}
                    />
                )}
                {retestW > 0 && (
                    <Segment
                        w={retestW}
                        color={colors.retest}
                        label={`Retest: ${retestW.toFixed(0)}%`}
                    />
                )}
                {pendingW > 0 && (
                    <div
                        style={{
                            width: `${pendingW}%`,
                            height: '100%',
                            background: 'transparent',
                        }}
                        title={
                            showTooltips
                                ? `Pending: ${pendingW.toFixed(0)}%`
                                : undefined
                        }
                    />
                )}
            </div>
        </div>
    )
}
